import Cache from './cache'
import Cookie from './cookie'
import Global from './global'
import { Api } from './api'
import { setTimeout } from 'timers';

export default {

    authorize_url: Global.SSO_END_POINT + 'connect/authorize',
    addclaims_authorize_url: Global.SSO_END_POINT + '/accountafterauth/claimsadd',
    endsession_url: Global.SSO_END_POINT + 'connect/endsession',
    redirect_uri: Global.SSO_REDIRECT_LOGIN_URL,
    post_logout_redirect_uri: Global.SSO_REDIRECT_LOGOUT_URL,

    client_id: Global.SSO_CLIENT_ID,
    response_type: Global.SSO_RESPONSE_TYPE,
    scope: Global.SSO_SCOPE,

    menu_key: 'PFB___FXX_JB_01',
    permissoes_key: 'PFB___FXX_JB_02',
    foto_key: 'PFB___FXX_JB_03',
    loadfinished_key: 'PFB___FXX_JB_04',
    lastlocation_key: 'PFB___AEF_03_5O',

    usuariosPermitidos: ['magda.araujo@cna.com.br',
        'fabricio.mainieri@cna.com.br',
        'camila.neves@cna.com.br',
        'thiago.guimaraes@cna.com.br',
        'talyta.syozi@cna.com.br',
        'alana.medeiros@cna.com.br',
        'daiane.fernandes@cna.com.br',
        'alexia.cardoso@cna.com.br',
        'cristiane.santos@cna.com.br',
        'kevellin.santos@cna.com.br',
        'daniela@cna.com.br',
        'ligiaalencar@cna.com.br',
        'danilozanutto@gmail.com',
        'guilherme.azevedo@cna.com.br',
        'laura.bianca@cna.com.br',
        'sofia.goncalves@cna.com.br',
        'daniele.galante@cna.com.br',
        'erotides.junior@cna.com.br',
        'eduardo.nardi@cna.com.br',
        'henry.garcia@cna.com.br',
        'gabriela.amorim@cna.com.br'
    ],

    rotasRestritas: ['certificacoes',
        'certificacoespoliticapreco',
        'certificacoesregrasisencao'],


    getToken: function () {
        return Cache.get(Global.ID_TOKEN);
    },

    getAccessToken: function () {
        return Cache.get(Global.ACCESS_TOKEN);
    },

    getState: function () {
        return Cache.get(Global.ID_STATE);
    },

    logged: function () {
        return Cache.get(Global.ID_TOKEN) && Cache.get(this.loadfinished_key) == "finished";
    },

    login: function (saveActualPage) {

        if (saveActualPage)
            Cache.add(this.lastlocation_key, window.location.pathname);

        Cache.add(Global.ID_STATE, Date.now());

        var url = this.authorize_url + "?" +
            "client_id=" + encodeURIComponent(this.client_id) + "&" +
            "redirect_uri=" + encodeURIComponent(this.redirect_uri) + "&" +
            "response_type=" + encodeURIComponent(this.response_type) + "&" +
            "scope=" + encodeURIComponent(this.scope) + "&" +
            "state=" + encodeURIComponent(this.getState()) + "&" +
            "nonce=xyz";

        window.location = url;
    },

    getCurrentUser: function (callback) {
        var api = new Api("currentuser");
        api.hasDefaultFilters = false;
        api.get().then(response => {
            var _user = response.data;
            _user.escolas = JSON.parse(_user.escolas)
            Cache.add(Global.USER_INFO, JSON.stringify(_user));
            setTimeout(() => { callback(_user) }, 500);
        });
    },

    currentUser: function () {
        var _user = JSON.parse(Cache.get(Global.USER_INFO));
        return _user;
    },

    logout: function () {

        var url = this.endsession_url + "?" +
            "id_token_hint=" + this.getToken() + "&" +
            "post_logout_redirect_uri=" + encodeURIComponent(this.post_logout_redirect_uri) + "&" +
            "state=" + encodeURIComponent(this.getState());

        this.reset();

        window.location = url;
    },

    processTokenCallback: function (callback) {

        if (window.location.href.indexOf("access_token") < 0) {
            callback();
            return;
        }

        this.reset();

        var itens = window.location.hash.split('#');
        var result = itens[1].split('&').reduce(function (result, item) {
            var parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
        }, {});

        Cache.add(Global.ACCESS_TOKEN, result.access_token, result.expires_in);
        Cache.add(Global.ID_TOKEN, result.id_token, result.expires_in);

        setTimeout(() => {
            callback();
        }, 500);

    },

    claimsAddLoginSso: function (claim_type, claim_value) {

        Cache.add(Global.ID_STATE, Date.now());

        let url = this.addclaims_authorize_url + "?" +
            "claims_type=" + encodeURIComponent(claim_type) + "&" +
            "claims_value=" + encodeURIComponent(claim_value) + "&" +
            "client_id=" + encodeURIComponent(this.client_id) + "&" +
            "redirect_uri=" + encodeURIComponent(this.redirect_uri) + "&" +
            "response_type=" + encodeURIComponent(this.response_type) + "&" +
            "scope=" + encodeURIComponent(this.scope) + "&" +
            "state=" + encodeURIComponent(this.getState()) + "&" +
            "nonce=xyz";

        Cache.remove(Global.USER_INFO);

        window.location = url;
    },

    reset: function () {
        Cache.remove(Global.ACCESS_TOKEN);
        Cache.remove(Global.ID_TOKEN);
        Cache.remove(Global.USER_INFO);
    },

    getPermissoes: function () {
        var _fromcache = Cache.get(this.permissoes_key);
        return JSON.parse(_fromcache);
    },

    getMenu: function () {
        var _fromcache = Cache.get(this.menu_key);
        return JSON.parse(_fromcache);
    },

    getFotoUser: function () {
        var _fromcache = Cache.get(this.foto_key);
        return _fromcache;
    },

    canAccess: function (url) {

        var user = this.currentUser();
        if (!user || user.tenant != 276)
            return false;

        if (this.rotasRestritas.includes(url.split('/').pop()) &&
            (this.usuariosPermitidos.includes(user.email) == false && user.email.includes('@targetsoftware.com.br') == false)) {
            return false;
        }

        return true;

        if (url == '' ||
            url == '/' ||
            url == '/home')
            return true;

        var permissions = this.getPermissoes();
        var can = false;

        if (url.endsWith("/"))
            url = url.slice(0, -1)

        var rotaSplited = url.split('/');

        for (var key in permissions) {
            var splited = permissions[key].split('/');
            var todosparametrosbatem = false;
            for (var itemrota in rotaSplited) {
                if (splited[itemrota] == "[parametro]" || rotaSplited[itemrota] == splited[itemrota]) {
                    todosparametrosbatem = true;
                }
                else {
                    todosparametrosbatem = false;
                    break;
                }
            }

            if (todosparametrosbatem) {
                can = true;
                break;
            }
        }

        if (!can)
            return false;

        return true;
    }
}
